module.exports = __webpack_public_path__ + "img/grk.81b703f3.png";